import { z } from 'zod';

export const FlowTestCasesRequestSchema = z
  .object({
    flowDefinitionId: z.uuid(),
  })
  .strict();
export type FlowTestCasesRequest = z.infer<typeof FlowTestCasesRequestSchema>;

export const FlowTestCaseBranchKindSchema = z.enum(['Conditional', 'Switch', 'Error']);
export type FlowTestCaseBranchKind = z.infer<typeof FlowTestCaseBranchKindSchema>;

export const FlowTestCaseBranchSchema = z
  .object({
    key: z.string(),
    blockId: z.string(),
    blockName: z.string(),
    kind: FlowTestCaseBranchKindSchema,
    outcome: z.string(),
    description: z.string(),
  })
  .strict();
export type FlowTestCaseBranch = z.infer<typeof FlowTestCaseBranchSchema>;

export const FlowTestCaseCoverageSchema = z
  .object({
    totalBranches: z.number().int().nonnegative(),
    coveredBranches: z.number().int().nonnegative(),
    coveredBranchKeys: z.array(z.string()),
    uncoveredBranches: z.array(FlowTestCaseBranchSchema),
  })
  .strict();
export type FlowTestCaseCoverage = z.infer<typeof FlowTestCaseCoverageSchema>;

export const GenerateFlowTestCasesResultSchema = z
  .object({
    csv: z.string(),
    testCaseCount: z.number().int().nonnegative(),
    coverage: FlowTestCaseCoverageSchema,
  })
  .strict();
export type GenerateFlowTestCasesResult = z.infer<typeof GenerateFlowTestCasesResultSchema>;

export const FlowTestCasesGenerationRequestIdSchema = z.uuid();

export const StartFlowTestCasesGenerationResponseSchema = z
  .object({
    requestId: FlowTestCasesGenerationRequestIdSchema,
    status: z.literal('Pending'),
  })
  .strict();
export type StartFlowTestCasesGenerationResponse = z.infer<
  typeof StartFlowTestCasesGenerationResponseSchema
>;

export const FlowTestCasesGenerationRequestStatusSchema = z.discriminatedUnion('status', [
  z
    .object({
      requestId: FlowTestCasesGenerationRequestIdSchema,
      status: z.literal('Pending'),
    })
    .strict(),
  z
    .object({
      requestId: FlowTestCasesGenerationRequestIdSchema,
      status: z.literal('Processing'),
    })
    .strict(),
  z
    .object({
      requestId: FlowTestCasesGenerationRequestIdSchema,
      status: z.literal('Succeeded'),
      result: GenerateFlowTestCasesResultSchema,
    })
    .strict(),
  z
    .object({
      requestId: FlowTestCasesGenerationRequestIdSchema,
      status: z.literal('Failed'),
      errorMessage: z.string().min(1),
    })
    .strict(),
]);
export type FlowTestCasesGenerationRequestStatus = z.infer<
  typeof FlowTestCasesGenerationRequestStatusSchema
>;
